// Components
import { IconButton } from '@mui/material';

// Core
import { renderColor } from '../../../core/utils';

const IconButtonCustom = ({
  ariaLabel = 'twitter',
  onClick = () => null,
  size,
  className = '',
  icon = null,
  disabled = false,
  typeColor = '',
  typeColorHover = '',
  padding = '8px',
  borderRadius = '50%',
}) => {
  return (
    <IconButton
      color="primary"
      aria-label={ariaLabel}
      disabled={disabled}
      className={className}
      onClick={onClick}
      sx={{
        width: size * 1.5,
        height: size * 1.5,
        padding: padding,
        backgroundColor: `${renderColor(typeColor)}`,
        '&:hover, &.Mui-focusVisible': {
          backgroundColor: `${renderColor(typeColor)}`,
        },
        '&.MuiButtonBase-root svg': {
          color: 'white',
          width: size,
          height: size,
          backgroundColor: `${renderColor(typeColor)}`,
          borderRadius: borderRadius,
        },
        '&:hover.MuiButtonBase-root svg': {
          color: `${renderColor(typeColorHover)}`,
        },
        '&.MuiTouchRipple-root': {
          backgroundColor: 'red',
        },
        color: renderColor(typeColor),
        ':hover': {
          color: `${renderColor(typeColorHover)}`,
        },
      }}
    >
      {icon}
    </IconButton>
  );
};

export default IconButtonCustom;
